
import React from 'react'
import DashBody from '../../../../Layout/Dashboard/DashBody'
import DashHeader from '../../../../Layout/Dashboard/DashHeader'
import LyTable from '../../../../Layout/Dashboard/LyTable'
import useTableColumns from './useTableColumns'
import { QueryStatusEnum } from '../../../../config/QueryStatus'
import { useNavigate, useParams } from 'react-router-dom'
import AddButton from '../../../../Layout/Dashboard/AddButton/AddButton'
import { useGetProjectImage } from '../../../../api/Project'

function Page() {

    const column   =useTableColumns()
    const {id} = useParams()
    const {data  ,status } = useGetProjectImage({project_id:id})
    const navigate = useNavigate()
    
  return (
    // Pass Status to Layout 
    <DashBody status={status as QueryStatusEnum} >

      <DashHeader showAddButton={false} title={'ProjectImage'}>
      <div className='RightSide d-flex gap-2 align-center '>

     <AddButton  onClick={()=>navigate('project_image/add')}></AddButton>
     </div>
      </DashHeader>

      
      <LyTable
        data={data?.data}
        isLoading={false}
        columns={column}
        is_pagination={false}
    />
      
    
    </DashBody>
  )
}

export default Page

